import { render, staticRenderFns } from "./customsgood.vue?vue&type=template&id=e6af8b26&"
import script from "./customsgood.vue?vue&type=script&lang=js&"
export * from "./customsgood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports